import env from 'src/env';

type language = {
    locale: string,
    prefix: string
};

const sparkUpLanguageUrl = (appLocale: string) => {
    const locales = env.sparkUpCoachingLocales;

    const foundLocale = locales.find((item: language) => item.locale === appLocale);

    if (foundLocale && foundLocale.prefix) {
        return `-${foundLocale.prefix}`;
    }

    return '';
};

export default sparkUpLanguageUrl;